import React, { useState, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').content;

const InviteUser = ({ touring_group_id, current_user_nickname, touring_group_title }) => {
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const timeoutId = useRef(null);

  const searchUsers = async (query) => {
    try {
      const response = await axios.get('/users/search', {
          params: {
              query
          }
      });

      if (Array.isArray(response.data)) {
        setUsers(response.data);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleQueryChange = (e) => {
    const newQuery = e.target.value;
    setQuery(newQuery);

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    // Initiate the search after the user has stopped typing for 700ms
    timeoutId.current = setTimeout(() => searchUsers(newQuery), 700);
  };

  const handleUserSelectChange = (e, userId) => {
    if (e.target.checked) {
      setSelectedUserIds([...selectedUserIds, userId]);
    } else {
      setSelectedUserIds(selectedUserIds.filter(id => id !== userId));
    }
  };

  const inviteUsers = async () => {
    try {
      await axios.post(`/touring_groups/${touring_group_id}/notifications`, {
        user_ids: selectedUserIds,
      });

      alert('ユーザーを招待しました');
      setSelectedUserIds([]); // Clear selection after inviting
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <table className="touring-table">
      <tbody>
        <tr>
          <td className="touring-table-invite">メンバー招待</td>
        </tr>
        <tr>
          <td className="touring-table-invite1">
            <input type="text" name='query' id='search' value={query} onChange={handleQueryChange} placeholder="名前、ニックネーム、地域、車名" />
          </td>
        </tr>
        {users.length > 0 && (
          <tr>
            <td>
              {users.map(user => (
                <div key={user.id} className="user-list-check">
                  <input type="checkbox" onChange={(e) => handleUserSelectChange(e, user.id)} />
                  <a href={`/users/${user.id}`}>
                      <div className='touring-table-invite-list'>
                        <img src={user.icon_img?.url || 'https://drivemate2023.s3.ap-northeast-1.amazonaws.com/uploads/user/user_default.png'} alt={`検索結果アイコン${user.id}`} />
                        <p className='touring-table-invite-list-nickname'>
                          {user.nickname.length > 14 ? `${user.nickname.substring(0, 14)}...` : user.nickname}
                        </p>
                      </div>
                  </a>
                </div>
              ))}
              <button onClick={inviteUsers} className="touring-table-invite-button">招待</button>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

InviteUser.propTypes = {
  touring_group_id: PropTypes.number,
  current_user_nickname: PropTypes.string,
  touring_group_title: PropTypes.string,
};

export default InviteUser;